import { Typography } from "@mui/material";
import {
	CustomerOfferToOrderApi,
	CustomerOfferToOrderApi_FormInitData,
} from "src/api/generated/erp/sales/customerOrderOffer/api/customerOfferToOrderApi.ts";
import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import i18n from "i18next";
import { FormSelectField } from "src/components/common/forms/fields/FormSelectField.tsx";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { requireRule } from "src/components/common/forms/validation.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface CreateOrderFromOfferFormProps extends FormCommonProps<void> {
	customerOrderOfferId: number;
}

interface FormValues {
	customerOrderTypeId: number;
}

type FormInitData = CustomerOfferToOrderApi_FormInitData;

export const CreateOrderFromOfferForm = ({
	customerOrderOfferId,
	onCompleted,
	onFormEdited,
}: CreateOrderFromOfferFormProps) => {
	return (
		<AsyncForm<FormInitData, FormValues, void>
			fetch={() => CustomerOfferToOrderApi.getFormInitData({ customerOrderOfferId })}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.sales.customerOffer.createOrderForm"),
				data: {
					customerOrderOfferId,
				},
			}}
			getDefaultValues={(data) => ({
				customerOrderTypeId: data.customerOrderTypeId ?? undefined,
			})}
			submitLabel={i18n.t("ok")}
			cancelLabel={i18n.t("cancel")}
			render={({ control, data }) => {
				if (data.customerOrderTypeId != null) {
					return (
						<Typography
							sx={{
								ml: 1,
							}}
						>
							{i18n.t("create_customer_order_from_offer_confirmation")}
						</Typography>
					);
				}
				return (
					<FormSelectField
						control={control}
						name={"customerOrderTypeId"}
						options={data.customerOrderTypeOptions}
						label={i18n.t("customer_order_type")}
						getOptionKey={(option) => option.customerOrderTypeId}
						getOptionLabel={(option) => option.name}
						rules={requireRule()}
					/>
				);
			}}
			submit={async (values, { data }) => {
				const customerOrderTypeId = data.customerOrderTypeId ?? values.customerOrderTypeId;
				await CustomerOfferToOrderApi.createCustomerOrderFromOffer({
					customerOrderOfferId,
					customerOrderTypeId,
				});
			}}
		/>
	);
};
